import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-8 sm:py-16 items-center justify-center pl-[20px] pr-[20px] pt-[20px] pb-[20px]" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #001a0d 30%, #000d08 60%, #0a0a0a 100%)'
  }} data-id="element-233">
      {/* Logo */}
      <div className="mb-4" data-id="element-234">
        <span className="text-[#39FF14] text-xl sm:text-2xl font-black tracking-widest" data-id="element-235">
          🇧🇷 PROFEPACK
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-[0px] text-[28px]" data-id="element-236">
        Todo tu año de Português
        <br data-id="element-237" />
        <span className="text-[#39FF14]" data-id="element-238">resuelto.</span>
      </h1>

      {/* Mockup image — LCP element, priority load con dimensiones explícitas */}
      <div className="w-full max-w-[240px] sm:max-w-[300px] md:max-w-sm mx-auto mb-4" style={{
      aspectRatio: '1/1'
    }} data-id="element-239">
        <img src="https://cdn.magicpatterns.com/uploads/kerWuax1vZCWhtTTYxKKrg/Sin_titulo_(420_x_420_px)_(7).png" alt="PROFEPACK MegaPack Português Listo — Combo Completo" className="w-full h-full object-contain" width={400} height={400} fetchPriority="high" data-id="element-240" />
      </div>

      {/* Subtitle */}
      <p className="text-[#39FF14] text-lg sm:text-2xl font-bold max-w-3xl mb-[10px]" data-id="element-241">
        "Listo para usar. Sin buscar más. Sin improvisar. Sin perder domingos."
      </p>

      {/* Body */}
      <p className="text-white sm:text-lg max-w-2xl mb-[2px] pt-[8px] pb-[8px] text-[16px]" data-id="element-242">
        El sistema para docentes de Portugués de primaria y secundaria en
        Argentina: año completo listo (actividades + evaluaciones +
        solucionarios), sin buscar ni armar desde cero.
      </p>

      {/* Pills */}
      <div className="flex flex-wrap mb-[10px] gap-[5px] items-center justify-center max-w-[340px] sm:max-w-none mx-auto" data-id="element-243">
        <span className="bg-black/50 border border-[#39FF14]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-244">
          📄 100% PDF
        </span>
        <span className="bg-black/50 border border-[#39FF14]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-245">
          ⚡ Acceso inmediato
        </span>
        <span className="bg-black/50 border border-[#39FF14]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-246">
          🇦🇷 Currículo Argentino
        </span>
        <span className="bg-black/50 border border-[#39FF14]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-247">
          📚 Primaria + Secundaria
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-green-pulse bg-[#39FF14] text-black font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#76FF03] transition-colors inline-block mb-5 w-full sm:w-auto max-w-sm" data-id="element-248">
        🇧🇷 → QUIERO MI MEGAPACK AHORA
      </a>

      {/* Trust badges */}
      <p className="text-gray-300 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-249">
        <span data-id="element-250">🛡️ Garantía 7 días sin preguntas</span>
        <span data-id="element-251">🔒 Pago 100% seguro</span>
        <span data-id="element-252">💳 Mercado Pago | Tarjeta | Transferencia</span>
      </p>
    </section>;
}